import WifiOffIcon from '@mui/icons-material/WifiOff';
import OutlinedPageBox from './OutlinedPageBox';
import CenteredContentLayout from './CenteredContentLayout';

function OfflineState({
  onRetry,
  isRetrying,
}: {
  onRetry: () => void;
  isRetrying?: boolean;
}) {
  return (
    <OutlinedPageBox>
      <CenteredContentLayout
        image={WifiOffIcon}
        title="You appear to be offline"
        description="We couldn't reach the network. Check your connection and try again."
        button={{
          text: 'Try Again',
          onClick: onRetry,
          loading: isRetrying,
        }}
        maxWidth="750px"
      />
    </OutlinedPageBox>
  );
}

export default OfflineState;
